import { render, staticRenderFns } from "./Blok7Imbangan.vue?vue&type=template&id=e81d2a38"
import script from "./Blok7Imbangan.vue?vue&type=script&lang=js"
export * from "./Blok7Imbangan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports